import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import { formatReportDate } from './fnbEodReportUtils'

function MetaItem({ label, value }) {
  return (
    <Col sm={6} lg={4} xl={3}>
      <p className="fnb-eod-meta__label mb-1">{label}</p>
      <p className="fnb-eod-meta__value mb-0">{value || '—'}</p>
    </Col>
  )
}

export default function FnbEodReportHeader({ header }) {
  if (!header) return null

  return (
    <Card body className="card--md fnb-eod-report-header">
      <Row className="g-3">
        <MetaItem label="Event" value={header.eventName} />
        <MetaItem label="Date" value={formatReportDate(header.reportDate)} />
        <MetaItem label="Location" value={header.venueName} />
        <MetaItem label="Stand" value={header.standName} />
        <MetaItem label="Manager" value={header.managerName} />
      </Row>
    </Card>
  )
}
